import IconContainer from '@/components/IconContainer'

export default function IconDash(props) {
  return (
    <IconContainer
      {...props}
      width="16"
      height="16"
      ariaLabel="Dash Icon"
      fill="currentColor"
    >
      <rect x="5" y="8" width="6" height="1" rx="0.5" />
    </IconContainer>
  )
}
